import React from 'react'
import { BtnV2, color, Icon, l } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import {
  AiAlwaysOnAutomationsActions,
  AiAlwaysOnAutomationsSelectors,
} from 'apps/aiAutomation/store/core'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { alert } from 'common/core'
import { AiAutomationScenario } from 'shared/api/requests/aiAutomation/schemas'

import cm from './styles.module.css'

export const SuccessTuning = () => {
  const dispatch = useAppDispatch()

  const isAiCommentsPublished = useAppSelector(
    AiAlwaysOnAutomationsSelectors.getIsSocialEngagementPublished,
  )

  const openAutomationEditor = () => {
    dispatch(
      AiAutomationLayoutActions.currentViewReplaced({
        view: SidebarViewType.POSITIVE_COMMENT_REPLIES,
      }),
    )

    AiAutomationAnalytics.logAutomationEditorOpened({
      type: AiAutomationScenario.SOCIAL_ENGAGEMENT,
      source: 'tov_success_setup',
    })
  }

  const enableCommentReplies = async () => {
    openAutomationEditor()

    if (isAiCommentsPublished) {
      alert(l.translate('Your changes were saved'), 'success')
      return
    }

    await dispatch(
      AiAlwaysOnAutomationsActions.updateScenarioStatus({
        scenario: AiAutomationScenario.SOCIAL_ENGAGEMENT,
        status: true,
      }),
    ).unwrap()

    AiAutomationAnalytics.logAutomationStatusChanged({
      type: AiAutomationScenario.SOCIAL_ENGAGEMENT,
      is_published: true,
      source: 'tov_success_setup',
    })
  }

  return (
    <div className={cm.successTuning}>
      <Icon.DoubleTick size={24} color={color.icon.brand} />
      <div>
        <h2 className="text-body font-medium">{l.translate('Tone matched!')}</h2>

        <p className="m-t-xxs text-secondary">
          {l.translate(
            "You've approved 3 drafts in a row. AI knows how you sound and is ready to reply to comments.",
          )}
        </p>
        <div className="d-flex justify-between m-t-md">
          <BtnV2 onClick={openAutomationEditor} variant="ghost-light">
            {l.translate('Keep reviewing')}
          </BtnV2>

          <BtnV2 onClick={enableCommentReplies} variant="primary">
            {isAiCommentsPublished
              ? l.translate('Save new tone')
              : l.translate('Turn on AI Comments')}
          </BtnV2>
        </div>
      </div>
    </div>
  )
}
